import { createContext, useContext } from "react";
/**
 * @remarks \@since 5.0.0
 * @internal
 */
var context = createContext({
    activeId: "",
    setActiveId: function () {
        throw new Error("ActiveDescendantMovementProvider must be a parent component.");
    },
});
context.displayName = "ActiveDescendant";
/**
 * @remarks \@since 5.0.0
 * @internal
 */
export var ActiveDescendantContextProvider = context.Provider;
/**
 * @remarks \@since 5.0.0
 * @internal
 */
export function useActiveDescendantContext() {
    return useContext(context);
}
//# sourceMappingURL=activeDescendantContext.js.map